<template>
  <div class="xin">
    <!-- tab 切换  -->
    <div class="switch" v-show="local_seven" v-loading="loading">
      <!-- 面包屑 -->
      <div class="main-find ">
        <span> {{ $t("logs.loacalsendmsg_a1") }}:</span>
        <el-input
          v-model="num"
          style="width:5%"
          @change="change_input"
        ></el-input>

        <el-select
          v-model="salt_minion_ip"
          placeholder="请选择"
          @change="change1"
          style="width:12%;margin-right:10px"
          v-if="this.show_salt == 1"
        >
          <el-option
            v-for="item in salt_minion_ipp"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <span>{{ $t("logs.loacalsendmsg_a2") }}:</span>
        <el-select
          v-model="showtime"
          placeholder="请选择"
          style="width:10%;margin-right:10px"
          @change="change2"
        >
          <el-option
            v-for="item in showtimee"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <!-- 指定某天-->
        <el-date-picker
          v-model="oneday"
          type="date"
          placeholder=""
          class="one_day"
          style="width:12%;margin-right:10px"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          v-show="time_oneday"
          :picker-options="pickerOptions"
          @change="oneday_day"
        >
        </el-date-picker>
        <!-- 自定义某天-->
        <el-date-picker
          v-model="startday"
          type="date"
          placeholder=""
          class="one_day"
          style="width:12%;margin-right:10px"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          v-show="time_startday"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
        <span v-show="time_startday">{{ $t("wasteInsulate1.zhi") }}</span>
        <el-date-picker
          v-model="endday"
          type="date"
          placeholder=""
          class="one_day"
          style="width:12%;margin-right:10px"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          v-show="time_startday"
          :picker-options="pickerOptions"
        >
        </el-date-picker>

        <el-button @click="save_send_search()" v-show="time_startday">{{
          $t("logs.ldap8")
        }}</el-button>
      </div>
      <el-tabs @tab-click="dianji">
        <!-- 邮件数  -->
        <el-tab-pane label="邮件数">
          <span slot="label">
            {{ $t("logs.loacalsendmsg1") }}
          </span>
          <div class="switch1">
            <div class="main">
              <p class="main_style_family">
                {{ this.search_show1 }}
                <span>{{ this.search_show2 }}</span>
              </p>
            </div>
            <div class="table table01">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList1"
                v-loading="loading"
              >
                <el-table-column
                  prop="REC"
                  :label="$t('logs.xuhao')"
                  width="60"
                ></el-table-column>
                <el-table-column
                  prop="SENDER"
                  label="Email"
                  width="180"
                ></el-table-column>
                <el-table-column
                  prop="NUM"
                  :label="$t('logs.loacalsendmsg1_a1')"
                  width="80"
                ></el-table-column>
                <el-table-column
                  prop="UPDATETIME"
                  :label="$t('logs.loacalsendmsg1_a2')"
                  width="150"
                ></el-table-column>
                <el-table-column
                  prop="VIEW24"
                  :label="$t('logs.loacalsendmsg1_a3')"
                ></el-table-column>
                <el-table-column
                  prop="address"
                  :label="$t('logs.audit6')"
                  width="100"
                >
                  <template slot-scope="scope">
                    <!-- 删除 -->

                    <el-button
                      @click="handleClick1(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query==0"
                    >
                      {{ $t("logs.loacalsendmsg1_a4") }}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>
        <!-- 大站点数 -->
        <el-tab-pane label="大站点数">
          <span slot="label">
            {{ $t("logs.loacalsendmsg2") }}
          </span>
          <div class="switch1" v-loading="loading">
            <div class="main">
              <p class="main_style_family">
                {{ this.search_show1 }}
                <span>{{ this.search_show2 }}</span>
              </p>
            </div>
            <div class="table table01">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList1"
                v-loading="loading"
              >
                <el-table-column
                  prop="REC"
                  :label="$t('logs.xuhao')"
                  width="60"
                ></el-table-column>
                <el-table-column
                  prop="SENDER"
                  label="Email"
                  width="180"
                ></el-table-column>
                <el-table-column
                  prop="NUM"
                  :label="$t('logs.loacalsendmsg1_a1')"
                  width="80"
                ></el-table-column>
                <el-table-column
                  prop="UPDATETIME"
                  :label="$t('logs.loacalsendmsg1_a2')"
                  width="150"
                ></el-table-column>
                <el-table-column
                  prop="VIEW24"
                  :label="$t('logs.loacalsendmsg1_a3')"
                ></el-table-column>
                <el-table-column
                  prop="address"
                  :label="$t('logs.audit6')"
                  width="100"
                >
                  <template slot-scope="scope">
                    <!-- 删除 -->

                    <el-button
                      @click="handleClick1(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query==0"
                    >
                      {{ $t("logs.loacalsendmsg1_a4") }}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>
        <!-- 字节数 -->
        <el-tab-pane label="字节数">
          <span slot="label">
            {{ $t("logs.loacalsendmsg3") }}
          </span>
          <div class="switch1" v-loading="loading">
            <div class="main">
              <p class="main_style_family">
                {{ this.search_show1 }}
                <span>{{ this.search_show2 }}</span>
              </p>
            </div>
            <div class="table table01">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList1"
                v-loading="loading"
              >
                <el-table-column
                  prop="REC"
                  :label="$t('logs.xuhao')"
                  width="60"
                ></el-table-column>
                <el-table-column
                  prop="SENDER"
                  label="Email"
                  width="180"
                ></el-table-column>
                <el-table-column
                  prop="NUM"
                  :label="$t('logs.loacalsendmsg1_a1')"
                  width="80"
                ></el-table-column>
                <el-table-column
                  prop="UPDATETIME"
                  :label="$t('logs.loacalsendmsg1_a2')"
                  width="150"
                ></el-table-column>
                <el-table-column
                  prop="VIEW24"
                  :label="$t('logs.loacalsendmsg1_a3')"
                ></el-table-column>
                <el-table-column
                  prop="address"
                  :label="$t('logs.audit6')"
                  width="100"
                >
                  <template slot-scope="scope">
                    <!-- 删除 -->

                    <el-button
                      @click="handleClick1(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query==0"
                    >
                      {{ $t("logs.loacalsendmsg1_a4") }}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>
        <!-- 收件人数 -->
        <el-tab-pane label="收件人数">
          <span slot="label">
            {{ $t("logs.loacalsendmsg4") }}
          </span>
          <div class="switch1" v-loading="loading">
            <div class="main">
              <p class="main_style_family">
                {{ this.search_show1 }}
                <span>{{ this.search_show2 }}</span>
              </p>
            </div>
            <div class="table table01">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList1"
                v-loading="loading"
              >
                <el-table-column
                  prop="REC"
                  :label="$t('logs.xuhao')"
                  width="60"
                ></el-table-column>
                <el-table-column
                  prop="SENDER"
                  label="Email"
                  width="180"
                ></el-table-column>
                <el-table-column
                  prop="NUM"
                  :label="$t('logs.loacalsendmsg1_a1')"
                  width="80"
                ></el-table-column>
                <el-table-column
                  prop="UPDATETIME"
                  :label="$t('logs.loacalsendmsg1_a2')"
                  width="150"
                ></el-table-column>
                <el-table-column
                  prop="VIEW24"
                  :label="$t('logs.loacalsendmsg1_a3')"
                ></el-table-column>
                <el-table-column
                  prop="address"
                  :label="$t('logs.audit6')"
                  width="100"
                >
                  <template slot-scope="scope">
                    <!-- 删除 -->

                    <el-button
                      @click="handleClick1(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query==0"
                    >
                      {{ $t("logs.loacalsendmsg1_a4") }}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>
        <!-- 对外域消息 -->
        <el-tab-pane label="对外域消息">
          <span slot="label">
            {{ $t("logs.loacalsendmsg5") }}
          </span>
          <div class="switch1" v-loading="loading">
            <div class="main">
              <p class="main_style_family">
                {{ this.search_show1 }}
                <span>{{ this.search_show2 }}</span>
              </p>
            </div>
            <div class="table table01">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList1"
                v-loading="loading"
              >
                <el-table-column
                  prop="REC"
                  :label="$t('logs.xuhao')"
                  width="60"
                ></el-table-column>
                <el-table-column
                  prop="SENDER"
                  label="Email"
                  width="180"
                ></el-table-column>
                <el-table-column
                  prop="NUM"
                  :label="$t('logs.loacalsendmsg1_a1')"
                  width="80"
                ></el-table-column>
                <el-table-column
                  prop="UPDATETIME"
                  :label="$t('logs.loacalsendmsg1_a2')"
                  width="150"
                ></el-table-column>
                <el-table-column
                  prop="VIEW24"
                  :label="$t('logs.loacalsendmsg1_a3')"
                ></el-table-column>
                <el-table-column
                  prop="address"
                  :label="$t('logs.audit6')"
                  width="100"
                >
                  <template slot-scope="scope">
                    <!-- 删除 -->

                    <el-button
                      @click="handleClick1(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query==0"
                    >
                      {{ $t("logs.loacalsendmsg1_a4") }}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>
        <!-- 对外域收件人 -->
        <el-tab-pane label="对外域收件人">
          <span slot="label">
            {{ $t("logs.loacalsendmsg6") }}
          </span>
          <div class="switch1" v-loading="loading">
            <div class="main">
              <p class="main_style_family">
                {{ this.search_show1 }}
                <span>{{ this.search_show2 }}</span>
              </p>
            </div>
            <div class="table table01">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList1"
                v-loading="loading"
              >
                <el-table-column
                  prop="REC"
                  :label="$t('logs.xuhao')"
                  width="60"
                ></el-table-column>
                <el-table-column
                  prop="SENDER"
                  label="Email"
                  width="180"
                ></el-table-column>
                <el-table-column
                  prop="NUM"
                  :label="$t('logs.loacalsendmsg1_a1')"
                  width="80"
                ></el-table-column>
                <el-table-column
                  prop="UPDATETIME"
                  :label="$t('logs.loacalsendmsg1_a2')"
                  width="150"
                ></el-table-column>
                <el-table-column
                  prop="VIEW24"
                  :label="$t('logs.loacalsendmsg1_a3')"
                ></el-table-column>
                <el-table-column
                  prop="address"
                  :label="$t('logs.audit6')"
                  width="100"
                >
                  <template slot-scope="scope">
                    <!-- 删除 -->

                    <el-button
                      @click="handleClick1(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query==0"
                    >
                      {{ $t("logs.loacalsendmsg1_a4") }}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>
        <!-- 对外域字节数 -->
        <el-tab-pane label="对外域字节数">
          <span slot="label">
            {{ $t("logs.loacalsendmsg7") }}
          </span>
          <div class="switch1" v-loading="loading">
            <div class="main">
              <p class="main_style_family">
                {{ this.search_show1 }}
                <span>{{ this.search_show2 }}</span>
              </p>
            </div>
            <div class="table table01">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList1"
                v-loading="loading"
              >
                <el-table-column
                  prop="REC"
                  :label="$t('logs.xuhao')"
                  width="60"
                ></el-table-column>
                <el-table-column
                  prop="SENDER"
                  label="Email"
                  width="180"
                ></el-table-column>
                <el-table-column
                  prop="NUM"
                  :label="$t('logs.loacalsendmsg1_a1')"
                  width="80"
                ></el-table-column>
                <el-table-column
                  prop="UPDATETIME"
                  :label="$t('logs.loacalsendmsg1_a2')"
                  width="150"
                ></el-table-column>
                <el-table-column
                  prop="VIEW24"
                  :label="$t('logs.loacalsendmsg1_a3')"
                ></el-table-column>
                <el-table-column
                  prop="address"
                  :label="$t('logs.audit6')"
                  width="100"
                >
                  <template slot-scope="scope">
                    <!-- 删除 -->

                    <el-button
                      @click="handleClick1(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query==0"
                    >
                      {{ $t("logs.loacalsendmsg1_a4") }}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="switch fenye_table" v-show="local_seven_detail">
      <!-- 查询框 -->
      <div class="main">
        <el-button @click="save_sender_hide()">{{
          $t("logs.Policy_back")
        }}</el-button>
        <!-- 发件账户查询 -->

        <el-button @click="tan1()"> {{ $t("list.sender") }}</el-button>
        <!-- 收件账户查询 -->

        <el-button @click="tan2()">{{ $t("list.receiver") }}</el-button>
        <!-- 本地发信失败 -->

        <el-button @click="tan3()">{{ $t("list.sender1") }}</el-button>
        <el-alert
          :title="this.HINT_QUERY_DETAIL"
          type="warning"
          show-icon
          :closable="false"
        ></el-alert>
      </div>

      <!--  表格 -->
      <div v-show="tanchu_two">
        <div class="table">
          <el-table
            v-loading="loading"
            :data="fileList2"
            :row-class-name="tableRowClassName"
            ref="multipleTable"
            tooltip-effect="dark"
            style="width: 100%"
            :cell-class-name="tableCellClassName"
          >
            <el-table-column :label="$t('table.tls')" width="40">
              <template slot-scope="scope">
                <img v-if="scope.row.SHOWTLS == 1" src="/imgs/tls.png" alt />
              </template>
            </el-table-column>
            <el-table-column
              prop="AC_DATE"
              :label="$t('table.maildate')"
              width="90"
            ></el-table-column>
            <el-table-column
              prop="SHOW_MINION"
              :label="$t('table.clusterhost')"
              width="96"
            ></el-table-column>

            <el-table-column
              prop="IP"
              :label="$t('table.IP')"
              width="102"
            ></el-table-column>
            <!--  发件人 -->

            <el-table-column
              prop="SENDER"
              :label="$t('table.ENVFROM')"
              width="166"
            >
            </el-table-column>

            <!--  收件人 -->

            <el-table-column
              prop="ENVRCPT"
              :label="$t('table.ENVRCPT')"
              width="166"
            >
            </el-table-column>

            <el-table-column
              prop="SUBJECT"
              :label="$t('table.SUBJECT')"
              :show-overflow-tooltip="true"
            >
            </el-table-column>

            <el-table-column
              prop="STATUS"
              :label="$t('table.status')"
              width="80"
            >
            </el-table-column>
            <el-table-column
              prop="RELAY"
              :label="$t('logs.Relay_target')"
              width="96"
            ></el-table-column>
          </el-table>
        </div>

        <!--  分页 -->
        <div class="fenye">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalnums"
          ></el-pagination>
        </div>
      </div>
    </div>
    <div class="pop-up" v-show="tanchu1" v-drag ="{ handle: '.pop_up_text_ipcor' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_ipcor"><span class="span_pad"></span> {{$t('logs.sender_query')}}</div>
                        <p></p>
      
      <div class="find">
        <div class="find1">
          <div class="find-text" style="padding-right:12px">
            Email :
          </div>
          <div class="block block1">
            <el-input v-model="email" placeholder="请输入Email"></el-input>
          </div>
        </div>
      </div>

      <el-row>
        <el-button type="primary" @click="save1()">{{
          $t("logs.save_a")
        }}</el-button>
        <el-button type="danger" @click="save12()">{{
          $t("logs.save_b")
        }}</el-button>
      </el-row>
    </div>
    <div class="gray" v-show="tanchu"></div>

    <!-- 弹出框2-->
    <div class="pop-up" v-show="tanchu2"  v-drag="{ handle: '.pop_up_text_tls_address' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_tls_address"><span class="span_pad"></span> {{$t('logs.sender_query1')}}</div>
                        <p></p>
    
      <div class="find">
        <div class="find1">
          <div class="find-text" style="padding-right:12px">
            Email :
          </div>
          <div class="block block1">
            <el-input v-model="email" placeholder="请输入Email"></el-input>
          </div>
        </div>
      </div>

      <el-row>
        <!-- 查询-->

        <el-button type="primary" @click="save2"
          >{{ $t("confirm.search") }}
        </el-button>
        <!-- 取消-->

        <el-button type="danger" @click="save22">{{
          $t("confirm.cancel")
        }}</el-button>
      </el-row>
    </div>
    <!-- 弹出框3-->
    <div class="table" v-show="tanchu3" v-loading="loading">
      <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%">
        <el-table-column prop="name" label="时间"> </el-table-column>

        <el-table-column prop="address" label="发件人"></el-table-column>
        <el-table-column prop="address" label="收件人"> </el-table-column>
        <el-table-column prop="address" label="邮件主题"> </el-table-column>

        <el-table-column prop="address" label="发送失败原因"> </el-table-column>
      </el-table>
    </div>
    <div class="gray" v-show="tanchu"></div>
    <!-- 弹出框1-->
  </div>
</template>

<script>
export default {
  data() {
    return {
      is_byte:'',
      HINT_QUERY_DETAIL: "",
      pickerOptions: {
        disabledDate(time) {
          // return time.getTime() > Date.now();
          return time.getTime() > Date.now() - 24 * 60 * 60 * 1000;
        },
      },
      endday: "",
      time_oneday: false,
      time_startday: false,
      startday: "",
      oneday: "",
      local_seven_detail: false,
      local_seven: true,
      salt_minion_ip: "127.0.0.1",
      salt_minion_ipp: [],
      showtime: 1,
      showtimee: [],
      num: "",
      input: "",
      fileList1: [],
      fileList: [],
      fileList2: [],
      search_show1: "",
      search_show2: "",
      tab_num: "",
      loading: false,
      // 总数
      totalnums: 0,
      size: 0,
      // 每页条数
      pagesize: 0,
      //   默认前往第几页
      page: 0,
      col: {
        email: "",
      },
      email: "",
      tanchu1: false,
      tanchu2: false,
      tanchu3: false,
      tanchu: false,
      tanchu_two: true,
      show_salt: 0,
      col_search: "",
      show_type: 0,
    };
  },
  mounted() {
    this.getFileList1();
    // this.getFileList2();
  },
  methods: {
    tan3() {
      this.loading = true;
      this.tanchu2 = false;
      this.tanchu3 = true;
      this.tanchu = false;
      this.tanchu_two = false;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);
      // console.log(this)
      // 获取表单数据,搜索条件
      let col = this.col;
      // console.log(col, "5555");

      this.$axios
        .get("/api/adm/cgi/mon.cgi", {
          params: {
            __mode: "show_sender_fail",
            sid: sid,
            col: col,

            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          console.log(res);
          // console.log(col, "传的col值");
          // this.col1 = this.col;
          // console.log(this.col1, "传的col1值");
          // console.log(this.page, '222')

          if(!res){
             this.loading = false;
          }
         else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading=false
            // this.getFileList();
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            alert("请重新登录");
            sessionStorage.removeItem("usermsg");
            this.$router.push({
              name: "login",
            });
          } else {
            this.fileList2 = res.data.ret.datalist;
            this.totalnums = res.data.ret.col.totalnums;
            this.size = res.data.ret.col.pagesize;
            this.page = res.data.ret.col.page;
            this.loading = false;
            this.show_type = 3;
            // console.log(this.col.startdate);
          }
        });
    },
    save2() {
      //

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);
      // console.log(this)
      // 获取表单数据,搜索条件
      let email = this.email;
      let col = {
        email,
      };
      console.log(col, "5555",this.col);
this.col=col
      this.$axios
        .get("/api/adm/cgi/mon.cgi", {
          params: {
            __mode: "query_rcptmsg",
            sid: sid,
            col: col,

            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          console.log(res);
          // console.log(col, "传的col值");
          // this.col1 = this.col;
          // console.log(this.col1, "传的col1值");
          // console.log(this.page, '222')

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            // this.loading = false

            // this.getFileList();
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            alert("请重新登录");
            sessionStorage.removeItem("usermsg");
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = true;
            this.tanchu_two = true;
            this.tanchu2 = false;
            this.tanchu3 = false;
            this.tanchu = false;

            this.fileList2 = res.data.ret.datalist;
            this.totalnums = res.data.ret.col.totalnums;
            this.size = res.data.ret.col.pagesize;
            this.page = res.data.ret.col.page;
            // this.email=res.data.ret.email
            this.loading = false;
            this.col_search = res.data.ret.col;
            console.log(this.col_search, "后台返回数据col，搜索后");
            this.show_type = 2;
            // console.log(this.col.startdate);
          }
        });
    },
    save22() {
      this.tanchu2 = false;
      this.tanchu = false;
    },
    save12() {
      this.tanchu1 = false;
      this.tanchu = false;
    },
    save1() {
      // this.tanchu_two = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);
      // console.log(this)
      // 获取表单数据,搜索条件
      let email = this.email;
      let col = {
        email,
      };
      // let col = this.col
      console.log(col, "5555",this.col);
this.col=col
      this.$axios
        .get("/api/adm/cgi/mon.cgi", {
          params: {
            __mode: "query_sendmsg",
            sid: sid,
            col: col,

            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          console.log(res);
          // console.log(col, "传的col值");
          // this.col1 = this.col;
          // console.log(this.col1, "传的col1值");
          // console.log(this.page, '222')

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            // this.loading = false

            // this.getFileList();
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            alert("请重新登录");
            sessionStorage.removeItem("usermsg");
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = true;
            this.tanchu_two = true;
            this.tanchu1 = false;
            this.tanchu3 = false;
            this.tanchu = false;
            this.fileList2 = res.data.ret.datalist;
            this.totalnums = res.data.ret.col.totalnums;
            this.size = res.data.ret.col.pagesize;
            this.page = res.data.ret.col.page;
            this.HINT_QUERY_DETAIL = res.data.ret.HINT_QUERY_DETAIL;

            this.loading = false;
            this.show_type = 1;

            // console.log(this.col.startdate);
          }
        });
    },
    // 原始日志
    tan1: function() {
      this.email = "";
      this.tanchu = true;
      this.tanchu1 = true;
      this.tanchu4 = true;
      // this.tanchu3 = false;
    },
    tan2: function() {
      this.email = "";
      this.tanchu = true;
      this.tanchu2 = true;
      this.tanchu4 = true;
      // this.tanchu3 = false;
    },
    // 分页数据
    getFileList() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);
      // console.log(this)
      // 获取表单数据,搜索条件

      let col = this.col;
      // console.log(col, '5555')
      let mode = "";
      if (this.show_type == 1) {
        mode = "query_sendmsg";
      } else if (this.show_type == 2) {
        mode = "query_rcptmsg";
      } else if (this.show_type == 3) {
        mode = "show_sender_fail";
      } else {
        mode = "query_sendmsg";
      }
      this.$axios
        .get("/api/adm/cgi/mon.cgi", {
          params: {
            __mode: mode,
            sid: sid,
            col: col,

            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          console.log(res);
          // console.log(col, "传的col值");
          this.col1 = this.col;
          // console.log(this.col1, "传的col1值");
          // console.log(this.page, '222')

          if(!res){
             this.loading = false;
          }
         else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading=false
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.fileList2 = res.data.ret.datalist;
            // 总条数
            this.totalnums = res.data.ret.col.totalnums;
            this.size = res.data.ret.col.pagesize;
            this.page = res.data.ret.col.page;

            this.loading = false;
          }
        });
    },
    // 当天数据
    handleClick1(index, scope) {
      this.loading = true;

      this.local_seven_detail = true;
      this.local_seven = false;
      // console.log(index, scope)
      this.col.email = scope.SENDER;
      // this.email = this.col.email
      let col = this.col;
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      // let str = this.$qs.stringify({
      //     __mode: "query_sendmsg",
      //     sid: sid,
      //     col: col,

      // });
      // console.log(str, '555')
      this.$axios
        .get("/api/adm/cgi/mon.cgi", {
          params: {
            __mode: "query_sendmsg",
            sid: sid,
            col: col,

            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          console.log(res), "加载每天";

          if(!res){
             this.loading = false;
          }
         else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading=false
            // this.getFileList();
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.fileList2 = res.data.ret.datalist;
            this.totalnums = res.data.ret.col.totalnums;
            this.size = res.data.ret.col.pagesize;
            this.page = res.data.ret.col.page;
            this.HINT_QUERY_DETAIL = res.data.ret.HINT_QUERY_DETAIL;
            this.loading = false;
            this.col_search = res.data.ret.col;
            console.log(this.col_search, "后台返回数据col");
            this.show_type = 1;
          }
        });
    },
    // 判断状态变色
    tableCellClassName({ row }) {
      // console.log(row, rowIndex);

      if (row.SENT == 1) {
        return "sent1";
      } else if (row.SENT == 0) {
        return "sent2";
      }
      return "";
    },
    // 只可以选择今天之前的日期

    // 每页显示多少条 -- 切换
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      // this.col = this.col_search;
      this.col.pagesize = val;

      this.getFileList();
    },
    // 当前第几页
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      // this.col = this.col_search;
      this.col.page = val;

      this.getFileList();
      // this.handleClick1()
    },
    // 各行变色
    tableRowClassName({ rowIndex }) {
      // console.log(row,rowIndex)
      if (rowIndex % 2 == 1) {
        return "warning-row";
        // console.log(2222)
      } else if (rowIndex % 2 !== 1) {
        return "success-row";
      }
      return "";
    },
    // 返回
    save_sender_hide() {
      this.local_seven_detail = false;
      this.local_seven = true;
      this.tanchu3=false
      this.getFileList1();
    },
    save_send_search() {
      this.getFileList1();
    },
    dianji(a) {
      // console.log(a.index)
      this.tab_num = a.index;
      this.getFileList1();
    },
    // 邮件数加载
    getFileList1() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);
      if (this.tab_num == 0) {
        this.tab_num = "msgs";
      } else if (this.tab_num == 1) {
        this.tab_num = "br";
      } else if (this.tab_num == 2) {
        this.tab_num = "by";
         this.is_byte=1
      } else if (this.tab_num == 3) {
        this.tab_num = "rcpt";
      } else if (this.tab_num == 4) {
        this.tab_num = "om";
      } else if (this.tab_num == 5) {
        this.tab_num = "or";
      } else if (this.tab_num == 6) {
        this.tab_num = "ob";
        this.is_byte=1
      }

      this.$axios
        .get("/api/adm/cgi/mon.cgi", {
          params: {
            __mode: "cmd_print_sort",
            sid: sid,
            showtime: this.showtime,
            show_b: this.tab_num,
            show_a: "omc",
            oneday: this.oneday,
            startday: this.startday,
            endday: this.endday,
            salt_minion_ip: this.salt_minion_ip,
            num: this.num,
            is_byte:this.is_byte,
          },
        })
        .then((res) => {
          console.log(res);

          if(!res){
             this.loading = false;
          }
         else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading=false
           
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.fileList1 = res.data.ret.datalist;
            this.search_show1 = res.data.ret.HINT;
            this.search_show2 = res.data.ret.TOTAL_VALUE;
            this.num = res.data.ret.num;
            this.salt_minion_ipp = res.data.ret.q_minion_host;
            this.showtimee = res.data.ret.q_showtime;
            if (res.data.ret.q_minion_host) {
              this.show_salt = 1;
            }
            if (this.showtime == 1) {
              this.oneday = res.data.ret.endday;
              this.startday = res.data.ret.startday;
              this.endday = res.data.ret.endday;
            }
          }
        });
    },
    oneday_day() {
      // console.log(a);
      this.getFileList1();
    },
    change_input(a) {
      // console.log(a);
      this.num = a;
      this.getFileList1();
    },
    // 下拉框点击选中
    change1(a) {
      // console.log(a);
      this.salt_minion_ip1 = a;
      this.getFileList1();
    },
    // 时间区间选中
    change2(a) {
      // console.log(a);
      this.showtime = a;
      if (this.showtime == 4) {
        this.time_oneday = true;
        this.time_startday = false;
      } else if (this.showtime == 5) {
        this.time_startday = true;
        this.time_oneday = false;
      } else {
        this.time_oneday = false;
        this.time_startday = false;
      }
      this.getFileList1();
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";
@import "../../css/drag.less";
@import "../../css/email_manage.less";

/deep/ .sent2 .cell {
  color: #f00 !important;
}

.table01 {
  /deep/ .has-gutter th:nth-child(1) {
    text-align: center;
  }

  /deep/ .has-gutter th:nth-child(3) {
    text-align: center;
  }

  /deep/ .has-gutter th:nth-child(6) {
    text-align: center;
  }

  // 表格居中位置
  /deep/ .el-table__row td:nth-child(1) {
    text-align: center;
  }

  /deep/ .el-table__row td:nth-child(3) {
    text-align: center;
  }

  /deep/ .el-table__row td:nth-child(6) {
    text-align: center;
  }
}

.main-find {
  // width: 100%;
  height: 50px;
  padding-left: 14px;
  // padding-bottom: 5px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: left;

  border-bottom: 2px solid #d2d7e6;
  // background: #FFFFFF;

  span {
    margin-right: 8px;

    // width: 126px;
    // display: inline-block;
    color: #0e2c5e;
  }

  .el-input {
    margin-right: 8px;
    width: 20%;
    line-height: 32px;
    height: 32px;
    // padding: 5px 10px 5px 0;
  }

  // input 框高度
  /deep/ .el-input__inner {
    height: 32px;
    padding: 0 6px;
  }

  /deep/ .el-input--suffix {
    // width: 150px;
    margin-right: 10px;
  }

  /deep/ .el-button {
    margin-right: 10px;
    // margin-left: 30px;
  }
}

//  条件下 搜索 button  按钮
.main-find /deep/ .el-button {
  padding: 8px 10px;

  background: #006be7;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
}

.main_style_family {
  font-family: PingFangSC-Medium, PingFang SC;
  color: #0e2c5e;
  font-size: 14px;
}

.fenye_table {
  padding: 14px 0;
}

.fenye_table .table {
  margin-bottom: 0;
}

.one_day {
  /deep/.el-input__inner {
    padding-left: 30px;
  }
}

// 隐藏滚动条
// .el-table ::-webkit-scrollbar {
//   width: 0px;
//   background: none;
// }
.cell img{
    width: 16px;
    height: 16px;
    display: block;
}
</style>
